import {
    fetchUsers,
    fetchCurrentUser,
    saveUser,
    newUser,
    removeUser,
    fetchUserInvitation,
    resetUser2FAToken
} from '@/api/users';
import { fetchClients, postLabels, impersonate, breakClientRelation } from '@/api/clients';
import { createClientInvitation } from '@/api/clientInvitations';
import { validateToken, createApplication } from '@/api/applications';
import {
    authorize,
    setAuthorizationHeader,
    deleteAuthorizationHeader,
    resetPasswordToken,
    resetPassword,
    updatePassword,
    reset2FA
} from '@/api/auth';
import { registerUser, registerInvitedUser, validatePartnerToken } from '@/api/signUp';
import { fetchPartner, patchPartner } from '@/api/partners';
import { fetchPartnerTransactions, fetchPartnerTransactionsSums } from '@/api/transactions';
import { fetchCommissionForPartner } from '@/api/commissions';

export function signIn(context, payload) {
    return authorize(payload).then(({ data }) => {
        setAuthorizationHeader(data);
        localStorage.setItem('MFPP.Auth', JSON.stringify(data));
        context.commit('setUser', {}); // TODO: Maybe have a separate flag for being logged in

        return fetchCurrentUser().then((response) => {
            context.commit('setUser', response.data);
            context.dispatch('getCommissionForPartner', response.data.partnerId);
            return response;
        });
    });
}

export function signOut(context) {
    return new Promise((resolve) => {
        deleteAuthorizationHeader();
        localStorage.removeItem('MFPP.Auth');
        localStorage.removeItem('MFPP.Auth.Actor');
        context.commit('setUser', null);
        context.commit('clearAllState');
        resolve();
    });
}

export function autoSignIn(context) {
    let data = JSON.parse(localStorage.getItem('MFPP.Auth'));
    if (!data) return new Promise((resolve, reject) => reject());
    context.commit('setUser', {}); // TODO: Maybe have a separate flag for being logged in

    setAuthorizationHeader(data);
    return fetchCurrentUser().then((response) => {
        context.commit('setUser', response.data);
        context.dispatch('getCommissionForPartner', response.data.partnerId);
        return response;
    });
}

export function changePassword(context, payload) {
    return updatePassword(payload);
}

export function getPartner(context, payload) {
    return fetchPartner(payload).then((response) => {
        context.commit('setPartner', response.data);
        return response;
    });
}

export function updatePartner(context, payload) {
    return patchPartner(payload).then(() => {
        context.commit('setPartner', payload);
    });
}

export function sendResetPasswordToken(context, payload) {
    return resetPasswordToken(payload);
}

export function sendResetPassword(context, payload) {
    return resetPassword(payload);
}

export function impersonateClient(context, payload) {
    return impersonate(payload);
}

export function getClients(context) {
    fetchClients().then(({ data }) => {
        context.commit('setClients', data);
        context.commit('setClientsLoaded', true);
    });
}

export function saveLabels(context, labels) {
    return postLabels(labels).then((response) => {
        context.commit('setLabels', response.data);
        return response;
    });
}

export function getUsers(context, partnerId) {
    return fetchUsers(partnerId).then((response) => {
        context.commit('setUsers', response.data);
        context.commit('setUsersLoaded', true);
    });
}

export function updateUser(context, payload) {
    return saveUser(payload).then((response) => {
        context.commit('removeUser', response.data);
        context.commit('addUser', response.data);
        return response;
    });
}

export function createUser(context, payload) {
    return newUser(payload).then((response) => {
        context.commit('addUser', response.data);
        return response;
    });
}

export function deleteUser(context, payload) {
    return removeUser(payload).then((response) => {
        context.commit('removeUser', payload);
        return response;
    });
}

export function getUserInvitation(context, token) {
    return fetchUserInvitation(token);
}

export function signUp(context, payload) {
    return registerUser(payload).then((response) => {
        context.commit('setSignUpUser', payload);
        context.commit('setQRCodeDetails', response.data);
    });
}

export function signUpUser(context, payload) {
    return registerInvitedUser(payload).then((response) => {
        context.commit('setSignUpUser', payload);
        context.commit('setQRCodeDetails', response.data);
    });
}

export function sendApplication(context, payload) {
    return createApplication(payload);
}

export function checkToken(context, payload) {
    return validateToken(payload);
}

export function createClientInvite(context, payload) {
    return createClientInvitation(payload).then((response) => {
        context.commit('addClientInvitation', response.data);
        return response;
    });
}

export function validatePartner(context, partnerToken) {
    return validatePartnerToken(partnerToken).then((response) => {
        return response;
    });
}
export function getPartnerTransactions(context, { partnerId, filters }) {
    fetchPartnerTransactions(partnerId, filters).then((response) => {
        context.commit('setPartnerTransactions', response.data);
    });
}

export function getPartnerTransactionsSums(context, { partnerId, filters }) {
    fetchPartnerTransactionsSums(partnerId, filters).then(({ data }) => {
        context.commit('setPartnerTransactionsSums', data);
    });
}

export function initPartnerTransactions(context, { partnerId, filters }) {
    context.commit('setPartnerTransactionsLoading', true);

    Promise.all([
        getPartnerTransactions(context, { partnerId, filters }),
        getPartnerTransactionsSums(context, { partnerId, filters })
    ])
        .then(() => {
            context.commit('setPartnerTransactionsLoading', false);
        })
        .catch(() => {
            context.commit('setPartnerTransactionsLoading', false);
        });
}

export function breakRelation(context, id) {
    return breakClientRelation(id).then(() => {
        context.commit('setClients', []);
        context.commit('setClientsLoaded', false);
        return getClients(context);
    });
}

export function getCommissionForPartner(context, partnerId) {
    if (!partnerId) return null;
    return fetchCommissionForPartner(partnerId).then((response) => {
        context.commit('setCommission', response.data);
        return response;
    });
}

export function clearStateAndReload(context) {
    context.commit('clearAllState');
    location.replace('/admin');
}

export function reset2FAToken(context, data) {
    return resetUser2FAToken(data);
}

export function resetUser2FA(context, payload) {
    return reset2FA(payload).then((response) => {
        context.commit('setSignUpUser', payload);
        context.commit('setQRCodeDetails', response.data);
    });
}
